import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRelatedPosts } from "./relatedPostsAPI";

const initialState = {
  isLoading: false,
  relatedPosts: [],
  error: "",
};

export const fetchRelatedPosts = createAsyncThunk(
  "relatedPosts/fetchRelatedPosts",
  async ({ id, tags }) => {
    const relatedPosts = await getRelatedPosts(id, tags);
    return relatedPosts;
  }
);

export const relatedPostsSlice = createSlice({
  name: "relatedPosts",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelatedPosts.pending, (state) => {
        state.isLoading = true;
        state.relatedPosts = [];
        state.error = "";
      })
      .addCase(fetchRelatedPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.relatedPosts = action.payload;
        state.error = "";
      })
      .addCase(fetchRelatedPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.relatedPosts = [];
        state.error = action.error?.message;
      });
  },
});

export default relatedPostsSlice.reducer;
